/* eslint-disable react/prop-types */
import Moveable, { DIRECTIONS } from "react-moveable";
import chair from "../../../assets/images/chair.png";
import user from "../../../assets/images/Profile.png";
// import BookingDetails from "./liveTable/BookingDetails";
import { useState } from "react";
import BookingDetails from "./LiveBookingDetails";
import { useDispatch, useSelector } from "react-redux";
import { DeMergeConfirmDialog } from "@/components/dialog/common-dialog";
import { toast } from "react-hot-toast";
import API from "@/api/lib/api";
import { fetchAllTables } from "@/redux/slice/table-slice/table-slice";

import { setSelectedLiveTable } from "@/redux/slice/table-slice/live-table-slice";
function LiveDraggAbleComponentView({ data, fullDetails }) {
  const dispatch = useDispatch();
  const { selectedRoom, table_merges } = useSelector((state) => state.table.table);
  const [isBookingDetailsModalOpen, setIsBookingDetailsModalOpen] = useState(false);


  const [selectedMergeForDeMerge, setSelectedMergeForDeMerge] = useState(null);
  const [deMergeDialog, setDeMergeDialog] = useState(false);
  const closeBookingDetails = () => {
    setIsBookingDetailsModalOpen(false);
  };

  const matchedMerge = table_merges?.find((merge) =>
    merge.tables?.some((table) => table.id === fullDetails?.id)
  );

  let mergedTableNames = null;

  if (matchedMerge) {
    const matchedTable = matchedMerge.tables.find(
      (table) => table.id === fullDetails?.id
    );

    const otherTables = matchedMerge.tables.filter(
      (table) => table.id !== fullDetails?.id
    );

    mergedTableNames = [
      matchedTable?.name,
      ...otherTables.map((table) => table.name),
    ].join(" + ");
  }
  const closeDeMergeDialog = () => {
    setDeMergeDialog(false);
  };
  const deMergeHandler = async () => {
    try {
      if (!selectedMergeForDeMerge) return;

      const payload = {
        table_ids: selectedMergeForDeMerge.tables.map((t) => t.id),
      };

      await API.put(
        `restaurant/table-merges/${selectedMergeForDeMerge.id}/unmerge`,
        payload
      );

      toast.success("Demerged successfully");

      if (selectedRoom?.id) {
        dispatch(fetchAllTables(selectedRoom.id));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "Something went wrong!");
    } finally {
      closeDeMergeDialog();
      setSelectedMergeForDeMerge(null);
    }
  };



  return (
    <>
      <div
        onClick={() => {
          setIsBookingDetailsModalOpen(true);
          dispatch(setSelectedLiveTable({
            liveTablePopup: true,
            liveTableDetails: {
              ...fullDetails,
              name: mergedTableNames || fullDetails.name,
            },
          }));
        }}
        id={data?.id}
        className="cursor-pointer absolute px-5 py-7 flex flex-col items-center justify-center gap-2"
        style={{
          ...data?.style,
          backgroundColor:
            fullDetails?.is_free
              ? "#525355"
              : fullDetails?.is_reserved
                ? "#83c27e"
                : fullDetails?.is_occupied
                  ? "#f95567"
                  : fullDetails?.is_checked_in
                    ? "#dfba23"
                    : "red",
        }}
      >
        <div>
          <div className="flex gap-3 items-center mb-5">
            <p className="text-sm font-semibold">{mergedTableNames || data?.name}</p>
            <div className="flex gap-2 items-center">
              <img className="h-3 w-2" src={chair} alt="chair-icon" />
              <p className="text-base font-medium">{fullDetails.seat}</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <img className="w-4" src={user} alt="user-icon" />
            <p>{fullDetails?.bookings[0]?.guest || '0'}</p>
          </div>
          <p className="flex items-center gap-1 py-2"><span className="py-1.5 px-3 rounded-full text-xs font-medium bg-gray-500 capitalize">{fullDetails?.status}</span><span className="px-3 py-1.5 rounded-full text-xs font-medium bg-white text-black">{fullDetails?.bookings.length > 0 ? '+1' : '0'}</span></p>
          {/* <p className="text-sm font-semibold">{fullDetails?.liveTableDetails[0]?.start_time}</p> */}
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold">
              {fullDetails?.bookings[0]?.start_time?.split(':').slice(0, 2).join(':')}
            </p>
            {mergedTableNames && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMergeForDeMerge(matchedMerge);
                  setDeMergeDialog(true);
                }}
                className="bg-black text-white font-medium text-xs rounded-full py-[5px] px-2.5"
              >
                Demerge
              </button>
            )}

          </div>

        </div>
      </div>

      {/* 
        <BookingDetails
          isOpen={isBookingDetailsModalOpen}
          onClose={closeBookingDetails}
          itemsDialog={fullDetails}
          tableType="live_table"
          setOrderDetailsId={setOrderDetailsId}
        /> */}
      <DeMergeConfirmDialog
        isOpen={deMergeDialog}
        onClose={closeDeMergeDialog}
        onConfirm={() => {
          deMergeHandler();
        }}
      />

    </>
  );
}

export default LiveDraggAbleComponentView;